import './App.css';
import DigitalMenu from './components/DigitalMenu';

function App({ cmp }) {
  return (
    <div className="App">
      <DigitalMenu company={cmp} />
    </div>
  );
}

export default App;
